import { gql, useQuery } from '@apollo/client';
import subscriptionsClient from 'lib/apollo/clients/subscriptions';

export const GET_USER_QUERY = gql`
  query user {
    user {
      uid
      email
      firstName
      lastName
      organizationUid
      jobTitle
      businessName
      phone
    }
  }
`;

const useUserQuery = () => {
  const { data, loading, error } = useQuery(GET_USER_QUERY, {
    client: subscriptionsClient,
  });

  const user = data?.user;

  return {
    error,
    loading,
    user,
  };
};

export default useUserQuery;
